import Vue from 'vue'
import App from './App.vue'
import router from '@/routers/router'
import store from './store/'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import CKEditor from 'ckeditor4-vue';
import { iniciarControlVersion } from '@/utils/versionCheck'

import 'vue-select/dist/vue-select.css';

import VueIziToast from 'vue-izitoast';

import 'izitoast/dist/css/iziToast.min.css';
import VueSwal from 'vue-swal'
import VueTimeago from 'vue-timeago'
import VueBarcodeScanner from 'vue-barcode-scanner'

Vue.config.productionTip = false

Vue.use(VueSwal)
Vue.use(CKEditor)
Vue.use(VueBarcodeScanner)

import VuePipeline from 'vue-pipeline'



Vue.filter('formatFechaHora', function (value) {
  if (value) {
    return moment(String(value)).locale("es").format('DD/MM/YYYY HH:mm')
  }
});

Vue.filter('formatFecha', function (value) {
  if (value) {
    return moment(String(value)).locale("es").format('DD/MM/YYYY')
  }
});

var filter = function (text, length, clamp) {
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);

Vue.use(VueIziToast);

Vue.component('v-select', vSelect)
Vue.component('datepicker', Datepicker)


Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'es', // Default locale
  locales: {
    es: require('date-fns/locale/es')
  }
})

iniciarControlVersion(router)


new Vue({
  router,
  store,
  render: h => h(App),
  beforeCreate() {
    Vue.$toast = this.$toast;
    Vue.$swal = this.$swal;
  },
}).$mount('#app')

